import { PollResponse } from "@infrastructure/Services/AuthService";
import {
    getLocalStoragePolls,
    setLocalStoragePolls,
} from "@infrastructure/Persistence/LocalUserStorage";
import { PostIdType } from "../../../Presentation/Components/Post/Post.types";

export function updateUserPolls(
    postId: PostIdType,
    newOptionId: number,
    quizAnswerOptionId: number | undefined,
) {
    const polls: PollResponse[] = getLocalStoragePolls();

    const poll = polls.find((poll) => poll.postId === postId);
    if (poll) {
        poll.optionId = newOptionId;
    } else {
        polls.push({
            postId: postId,
            optionId: newOptionId,
            quizAnswerOptionId: quizAnswerOptionId,
        });
    }

    setLocalStoragePolls(polls);
}

export function deleteUserPoll(postId: PostIdType) {
    const polls: PollResponse[] = getLocalStoragePolls();
    const updatedPolls = polls.filter((poll) => poll.postId !== postId);

    setLocalStoragePolls(updatedPolls);
}
